export default __webpack_public_path__ + "static/media/phone.205787a6.svg";